import styled from 'styled-components';
import {device} from '../../../../../utils/device';

export const Container = styled.div`
  width: 380px;
  padding: 30px 12px 10px 12px;
  border-radius: 2px;
  background-color: #4a9794;
  position: absolute;
  left: 0;
  top: 115%;
  z-index: 1;
  &:after {
    bottom: 100%;
    left: 20px;
    border: solid transparent;
    content: '';
    height: 0;
    width: 0;
    position: absolute;
    pointer-events: none;
    border-color: rgba(74, 151, 148, 0);
    border-bottom-color: #4a9794;
    border-width: 6px;
    margin-left: -6px;
  }
  @media ${device.mobileS} {
    width: 100%;
    position: relative;
    left: unset;
    top: unset;
    margin-top: 10px;
  }
`;
export const PlaceholderImg = styled.img`
  width: 100%;
  height: 85px;
  border-radius: 4px;
`;
export const PlaceholderText = styled.p`
  font-size: 10px;
  font-weight: 900;
  color: #fff;
  margin-top: 5px;
`;
export const TooltipClose = styled.span`
  width: 18px;
  height: 18px;
  background-color: #fff;
  border-radius: 50%;
  position: absolute;
  right: 4px;
  top: 4px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  &:before,
  &:after {
    position: absolute;
    left: 8px;
    content: ' ';
    height: 11px;
    width: 2px;
    background-color: #4a9794;
  }
  &:before {
    transform: rotate(45deg);
  }
  &:after {
    transform: rotate(-45deg);
  }
`;
